import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Home, Calendar, CalendarPlus, User } from 'lucide-react'
import { cn } from '@/lib/utils'

const NAV_ITEMS = [
  { key: 'home', tKey: 'mobile.nav.home', icon: Home, route: '/dashboard' },
  { key: 'calendar', tKey: 'mobile.nav.calendar', icon: Calendar, route: '/calendar' },
  { key: 'events', tKey: 'mobile.nav.events', icon: CalendarPlus, route: '/events' },
  { key: 'profil', tKey: 'mobile.nav.profile', icon: User, route: '/profil' },
] as const

export function BottomNav() {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-neutral-200 bg-white/95 pb-[env(safe-area-inset-bottom,0px)] backdrop-blur-sm">
      <div className="flex h-14 items-center justify-around">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.route || location.pathname.startsWith(item.route + '/')
          const Icon = item.icon
          return (
            <button
              key={item.key}
              onClick={() => navigate(item.route)}
              className={cn(
                'flex flex-col items-center gap-0.5 px-4 py-1 transition-colors',
                isActive ? 'text-primary' : 'text-neutral-400',
              )}
            >
              <Icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
              <span className="text-[10px] font-semibold">{t(item.tKey)}</span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
